import { 
    ACTUALIZAR_LIST_NIVEL2,
    AGREGAR_NIVEL2,
  } from "./nivel2Actions";

  const nivel2Reducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_NIVEL2: {
            return {
                ...state,
                nivel2List: action.payload
            }
        };

        case AGREGAR_NIVEL2:{
            return {
                 ...state,
                 nivel2List: [action.payload, ...state.nivel2List]
             }
         };

        default:
            return state;

    }
  }

  export default nivel2Reducer;